<template>
  <ScrollTable
    ref="table"
    :sourceList="detailData.data"
    emptyText="전송이력은 2020년 8월 12일 이후에 등록된 소식에서 볼 수 있습니다."
  >
    <template #header>
      <caption>
        <span class="blind">반복/맞춤소식 전송이력 - daily</span>
      </caption>
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col width="30%" />
      </colgroup>
      <thead class="table_list_head">
        <tr>
          <th>번호</th>
          <th>전송건수</th>
          <th>알림 성공수</th>
          <th>전송종류</th>
          <th>전송시간</th>
        </tr>
      </thead>
    </template>
    <template #row="{ rowData }">
      <tr>
        <td>{{rowData._index + 1}}</td>
        <td>
          <button
            type="button"
            class="link_modal"
            @click="$emit('viewRcp', rowData.sendDate)"
          >{{rowData.rcpCount || rowData.sendCount}}</button>
        </td>
        <td>
          <button
            type="button"
            class="link_modal"
            @click="$emit('viewRcp', rowData.sendDate)"
          >{{rowData.successCount}}</button>
        </td>
        <td>{{getRepeatSendTypeText(rowData.sendType)}}</td>
        <td>
          <button
            type="button"
            class="link_modal"
            @click="$emit('viewRcp', rowData.sendDate)"
          >{{$utils.timeText(rowData.sendDate)}}</button>
        </td>
      </tr>
    </template>
  </ScrollTable>
</template>

<script>
import newsMixin from "$views/News/_mixin";

export default {
  mixins: [newsMixin],
  props: {
    detailData: Object
  }
};
</script>

<style>
</style>